import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import footerList from './FooterList';
import Accordion from 'Components/Accordion';
import Icon from 'Components/Icon';
import MarketingIcons from 'Components/MarketingIcons';
import { classnames } from 'Utils/classnames';
import assetUrl from 'Utils/assetUrl';
import EnvironmentManager from 'Utils/environmentManager';
import { getDisplayCommunicationSettings } from 'Store/actions';
import { getStaticScreen } from 'Store/actions';
import { withMixpanel } from 'Utils/mixpanel';
import History from 'Store/history';
import { Badge } from '../Badge';

class Footer extends Component {
  static propTypes = {
    device: PropTypes.object,
    type: PropTypes.string,
    platform: PropTypes.string,
    helpMenuCategories: PropTypes.object,
    updater: PropTypes.object,
    getDisplayCommunicationSettings: PropTypes.func,
    staticScreen: PropTypes.object,
    getStaticScreen: PropTypes.func,
    mixpanel: PropTypes.object,
    auth: PropTypes.object,
    path: PropTypes.string,
  };

  redirectRaffleUrl = () => {
    if (!this.props.auth?.data?.accessToken)
      History.push('/sans-oyunlari/esya-piyangosu');
    else {
      this.props.getDisplayCommunicationSettings().then(res => {
        if (
          this.props.auth?.data?.accessToken
          && res?.data?.displayable
          && !(
            res?.data?.contactPermission.campaignEmail
            && res?.data?.contactPermission.campaignSms
            && res?.data?.contactPermission.campaignCallCenter
          )
        )
          History.push('/esya-piyangosu/iletisim-izinleri', {
            deeplinkParam: false,
          });
        else {
          History.push('/sans-oyunlari/esya-piyangosu');
        }
      });
    }
  };

  redirectNotAccordionLink = item => {
    const blogLink = EnvironmentManager.getMessageText({ key: 'bilyoner_blog_footer_link' });

    if (item.title === 'EŞYA PİYANGOSU') {
      return this.redirectRaffleUrl();
    } else if (item.title === 'YARDIM') {
      return window.open('https://yardim.bilyoner.com', '_blank');
    } else if (item?.title === 'BİLYONER BLOG') {
      return window.open(blogLink, '_blank');
    } else {
      History.push(item.path);
    }
  };


  componentDidMount () {
    if (
      !this.props.staticScreen.isLoading
      && !this.props.staticScreen?.data?.length
    ) {
      this.props.getStaticScreen();
    }
  }

  renderList = () => {
    const { helpMenuCategories, staticScreen } = this.props;

    const isRaffleVisible
      = EnvironmentManager.getMessageText({ key: 'raffle_main_page_visible' })
      === 'true';

    const isZendeskActive
      = EnvironmentManager.getMessageText({
        key: 'is_zendesk_live',
      }) === 'true';

    const modifiedFooterList = footerList.map(item =>
      item.title === 'YARDIM'
        ? {
          ...item,
          list: isZendeskActive ? [] : helpMenuCategories?.data,
          path: isZendeskActive ? '/' : '/yardim/yardim-konulari',
        }
        : item
    );

    if (!isRaffleVisible) {
      const raffleIndex = modifiedFooterList.findIndex(
        i => i.title === 'EŞYA PİYANGOSU'
      );
      modifiedFooterList.splice(raffleIndex, 1);
    }

    // Sorumlu Oyun footerList'te statik tanımlı; servisten de gelirse çift görünmesin.
    const modifiedStaticList = staticScreen?.data?.filter(item => item.url !== '/sorumlu-bahis').map((item, index) => ({
      ...item,
      static: true,
    }));

    let mergeList = [...modifiedFooterList, ...modifiedStaticList];

    return mergeList.map((item, index) => {
      if (item.list?.length > 0) {
        return this.renderAccordionItem(item, index);
      } else {
        if (item.static) {
          return this.renderNotAccordionStaticItem(item, index);
        } else {
          return this.renderNotAccordionItem(item, index);
        }
      }
    });
  };

  renderAccordionItem = (item, index) => {
    if (
      item.visibleKeyProps
      && !(
        EnvironmentManager.getMessageText({ key: item.visibleKeyProps })
        === 'true'
      )
    ) {
      return null;
    }

    return (
      <Accordion key={ index } title={ item.title }>
        { item.list.map((listItem, listIndex) => {
          if (
            listItem.visibleKeyProps
            && !(
              EnvironmentManager.getMessageText({
                key: listItem.visibleKeyProps,
              }) === 'true'
            )
          ) {
            return null;
          }

          return (
            <ul key={ listIndex }>
              <li className="accordion__content--list">
                <Link
                  to={ listItem.path }
                  title={ listItem.content }
                  { ...(item.linkOptions || listItem.linkOptions) }
                  onClick={ event => {
                    if (event?.target?.title === 'Çoklu Maç Takibi') {
                      this.props.mixpanel.track(
                        'Click Main Page Multiple LMT',
                        { 'Click Source': 'Footer' }
                      );
                    }
                    if (listItem.path.startsWith('/sans-oyunlari')) {
                      window.location.href = listItem.path;
                    }
                  } }
                >
                  { listItem.content }
                </Link>
              </li>
            </ul>
          );
          
        }) }
      </Accordion>
    );
  };

  renderNotAccordionItem = (item, index) => {
    if (
      item.visibleKeyProps
      && !(
        EnvironmentManager.getMessageText({ key: item.visibleKeyProps })
        === 'true'
      )
    ) {
      return null;
    }

    return (
      <div key={ index }>
        { item.title === 'EŞYA PİYANGOSU' ? (
          <Link
            className="footer__menu__not-accordion"
            to={ item.path }
            title={ item.title }
            onClick={ () => this.redirectRaffleUrl() }
            { ...item.linkOptions }
          >
            <div className="footer__menu__not-accordion--text">
              { item.title }
            </div>
          </Link>
        ) : (
          <Link
            className={ (`${item?.className} footer__menu__not-accordion`) }
            to={ item.path }
            onClick={ event => {
              item.title === 'TRİBÜN'
                && this.props.mixpanel.track('Click Main Page Tribun', {
                  'Area Type': 'Footer',
                });
              item.title === 'KAMPANYALAR'
                && this.props.mixpanel.track('Click Main Page Campaigns', {
                  'Area Type:': 'Footer',
                });
              item.title === 'LİG MERKEZİ'
              && this.props.mixpanel.track('View League Center Page', {
                'Click Point': 'Footer',
              });
              if (item.title === 'BİLYONER BLOG') {
                event.preventDefault();
              }
              this.redirectNotAccordionLink(item);

            } }
            title={ item.title }
            { ...item.linkOptions }
          >
            <div className="footer__menu__not-accordion--text">
              { item.title }
              { item.badgeNew && <Badge isNew="true" className={ 'new-badge' }>Yeni</Badge> }
            </div>
          </Link>
        ) }
        <hr className="footer__menu__horizontal-line" />
      </div>
    );
  };

  renderNotAccordionStaticItem = (item, index) => {
    return (
      <div key={ index }>
        <Link
          className="footer__menu__not-accordion"
          title={ item.name?.toUpperCase() }
          to={ '/bilyoner' + item.url }
          { ...item.linkOptions }
        >
          <div className="footer__menu__not-accordion--text">
            { item.name?.toUpperCase() }
          </div>
        </Link>
        <hr className="footer__menu__horizontal-line" />
      </div>
    );
  };

  render () {
    const { device, type, platform, path } = this.props;
    const informationSecurityPolicyTitle = EnvironmentManager.getMessageText({ key: 'information_security_policy_title' });
    const hasMenu = type === 'mobile-without-menu';
    const footerClass = classnames({
      footer: true,
      'footer--without-menu': hasMenu,
      'footer--invisible':
        device?.type === 'mobile'
        && path.includes('sanal-bahis/')
        && path.includes('sans-oyunlari/')
        && !path.includes('sans-oyunlari/esya-piyangosu')
        && !path.includes('sans-oyunlari/oyna-kazan'),
    });

    return (
      <footer className={ footerClass }>
        <div className="footer__content">
          <MarketingIcons platform={ platform } device={ device } />
        </div>
        { !hasMenu && (
          <div className="footer__content">
            <div className="footer__menu">{ this.renderList() }</div>
          </div>
        ) }
        <div className="footer__content">
          <div className="footer__sponsorship">
            <p>SPONSORLUKLARIMIZ</p>
            <div className="footer__sponsorship__logos">
              <img
                src={ assetUrl('anadolu-efes-100x100.png') }
                alt="Anadolu Efes"
              />
              <img src={ assetUrl('tsyd-100x100.png') } alt="TSYD" />
            </div>
          </div>
        </div>
        <div className="footer__full-width">
          <div className="footer__content">
            <div className="footer__warn">
              { !path.includes('sorumlu-bahis') && (
                <div className="footer__warn__legal-limit">
                  <Icon
                    className="footer__warn__legal-limit__legal-age"
                    iconName="svgAge18"
                  />
                  <span className="footer__warn__legal-limit__warn truncate-three-line-break-word">
                    { EnvironmentManager.getMessageText({
                      key: 'description_about_legal_warning',
                    }) }
                  </span>
                </div>
              ) }
              <div className="footer__warn__iddaa">
                <Icon
                  className="footer__warn__iddaa__logo"
                  iconName="svgIddaaLogo"
                />
                <Icon
                  className="footer__warn__iddaa__spor-toto"
                  iconName="svgSporToto"
                />
                <Icon
                  className="footer__warn__iddaa__united-racing"
                  iconName="svgUnitedRacing"
                />
                <Icon
                  className="footer__warn__iddaa__mp"
                  iconName="svgFooterMP"
                />
                <Icon
                  className="footer__warn__iddaa__virtual-race"
                  iconName="svgVirtualHorseRace"
                />

              </div>
            </div>
          </div>
        </div>
        <div className="footer__content">
          <div className="footer__site-map">
            <ul className="footer__site-map__vertical-list">
              <Link to="/kvkk" title="KVKK Aydınlatma Metni" rel="nofollow">
                <li className="footer__site-map__vertical-list__vertical-item">
                  KVKK Aydınlatma Metni
                </li>
              </Link>
              <span className="footer__site-map__vertical-list__vr"/>
              <Link to="/bilgi-guvenligi-politikasi" title={ informationSecurityPolicyTitle }>
                <li className="footer__site-map__vertical-list__vertical-item">
                  { informationSecurityPolicyTitle }
                </li>
              </Link>
              <span className="footer__site-map__vertical-list__vr"/>
              <Link
                to="/uyelik-sozlesmesi"
                title="Üyelik Sözleşmesi"
                rel="nofollow"
              >
                <li className="footer__site-map__vertical-list__vertical-item">
                  Üyelik Sözleşmesi
                </li>
              </Link>
              <span className="footer__site-map__vertical-list__vr"/>
              <Link
                to="/bilgi-toplumu-hizmetleri"
                title="Bilgi Toplumu Hizmetleri"
                rel="nofollow"
              >
                <li className="footer__site-map__vertical-list__vertical-item">
                  Bilgi Toplumu Hizmetleri
                </li>
              </Link>
              <span className="footer__site-map__vertical-list__vr"/>
              <Link to="/hakkimizda" title="Hakkimizda">
                <li className="footer__site-map__vertical-list__vertical-item">
                  Hakkımızda
                </li>
              </Link>
              <span className="footer__site-map__vertical-list__vr"/>
              <Link to="/kunye" title="Künye">
                <li className="footer__site-map__vertical-list__vertical-item">
                  Künye
                </li>
              </Link>
            </ul>
            <div>
              <p className="footer__site-map__copyright">
                Copyright @ { new Date().getFullYear() }, Bilyoner İnteraktif
                Hizmetler A.Ş.
              </p>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

const mapStateToProps = state => ({
  helpMenuCategories: state.cms.helpMenuCategories,
  updater: state.cms.updater,
  staticScreen: state.staticScreen,
  auth: state.auth,
});

export default connect(mapStateToProps, {
  getStaticScreen,
  getDisplayCommunicationSettings,
})(withMixpanel(Footer));
